import "../enums/accordion.js";
import "../enums/alert.js";
import "../enums/avatar.js";
import "../enums/breakpoints.js";
import { ButtonLooks } from "../enums/button.js";
import "../enums/code-editor.js";
import { BrandfolderHexColors } from "../enums/colors.js";
import "../enums/combobox.js";
import "../enums/date.js";
import "../enums/drag-and-drop.js";
import "../enums/dialog.js";
import "../enums/divider.js";
import "../enums/dropdown.js";
import "../enums/fieldset.js";
import "../enums/font-icon.js";
import "../enums/fonts.js";
import "../enums/headings.js";
import "../enums/input.js";
import "../enums/keys.js";
import "../enums/list.js";
import "../enums/listbox.js";
import { LoaderLooks } from "../enums/loader.js";
import "../enums/margin.js";
import "../enums/option.js";
import "../enums/pill.js";
import "../enums/placements.js";
import "../enums/popout.js";
import "../enums/privacy.js";
import "../enums/radio-group.js";
import "../enums/status.js";
import "../enums/switch.js";
import "../enums/table.js";
import "../enums/tooltip.js";
import "../enums/transitions.js";
import "../enums/widths.js";
import { brandfolderColorPalette } from "./colors.js";
var defaultLightShimmerLoader = {
  gradientDark: BrandfolderHexColors.DirtyMarshmallow,
  gradientLight: BrandfolderHexColors.Marshmallow
};
var blackLoader = {
  strokeFromColor: BrandfolderHexColors.Black,
  strokeToColor: BrandfolderHexColors.GrayDark,
  textColor: BrandfolderHexColors.Black
};
var primaryDarkLoader = {
  strokeFromColor: brandfolderColorPalette.primary[400],
  strokeToColor: brandfolderColorPalette.primary[200],
  textColor: BrandfolderHexColors.White
};
var primaryLightLoader = {
  strokeFromColor: brandfolderColorPalette.primary[500],
  strokeToColor: brandfolderColorPalette.primary[300],
  textColor: BrandfolderHexColors.Black
};
var warningLoader = {
  strokeFromColor: BrandfolderHexColors.WarningRed,
  strokeToColor: '#F41D38',
  textColor: BrandfolderHexColors.Black
};
var grayLoader = {
  strokeFromColor: brandfolderColorPalette.neutrals[400],
  strokeToColor: brandfolderColorPalette.neutrals[300],
  textColor: brandfolderColorPalette.neutrals[400]
};
var whiteLoader = {
  strokeFromColor: BrandfolderHexColors.White,
  strokeToColor: BrandfolderHexColors.GrayMedium,
  textColor: BrandfolderHexColors.White
};
/**
 * Get `LoaderLooks` from `ButtonLooks`
 * @param look ButtonLooks
 * @returns LoaderLooks
 */
var getLoaderLookFromButtonLook = function getLoaderLookFromButtonLook(look) {
  switch (look) {
    case ButtonLooks.Default:
      {
        return LoaderLooks.Primary;
      }
    case ButtonLooks.Primary:
      {
        return LoaderLooks.Gray;
      }
    case ButtonLooks.Secondary:
      {
        return LoaderLooks.Gray;
      }
    case ButtonLooks.Tertiary:
      {
        return LoaderLooks.Gray;
      }
    case ButtonLooks.Warning:
      {
        return LoaderLooks.Gray;
      }
    default:
      {
        return LoaderLooks.White;
      }
  }
};
export { blackLoader, defaultLightShimmerLoader, getLoaderLookFromButtonLook, grayLoader, primaryDarkLoader, primaryLightLoader, warningLoader, whiteLoader };